<script setup>
import { computed, defineProps, defineEmits } from 'vue'

const props = defineProps({
    modelValue: {
        type: [Boolean,String,Number],
        default: null
    },
    checked: {
        type: [Boolean, String, Number],
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const isChecked = computed(() => {
    return ['true', true, 1, '1'].includes(props.modelValue ?? props.checked)
})

const emit = defineEmits(['update:modelValue', 'change'])

const toggle = () => {
    if (props.disabled) return

    const newValue = !isChecked.value
    emit('update:modelValue', newValue)
    emit('change', newValue)
}
</script>

<template>
    <div v-bind="$attrs" class="relative inline-flex items-center gap-2 cursor-pointer" @click="toggle" :class="{ '!cursor-not-allowed': disabled }">
        <div class="focus:ring focus:ring-[#7F56D9] relative w-[36px] h-[20px] rounded-full transition p-0.5" :class="{ 'bg-[#7F56D9]': isChecked, 'bg-[#F2F4F7]': !isChecked }">
            <div class="absolute shadow-md bg-white z-10 w-[16px] h-[16px] rounded-full left-[2px] top-[2px] transition duration-200" :class="{ 'translate-x-full': isChecked }"></div>
        </div>
        <div v-if="$slots.default" class="text-[#374A61] text-sm font-medium leading-6 relative">
            <slot></slot>
        </div>
        <slot name="content"></slot>
    </div>
</template>
